module.exports = __webpack_public_path__ + "static/img/game-logo-cq9.5bff4bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-cq9.png
// module id = QjPv
// module chunks = 0 1 2 3 4 5 6